var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSfTechWeekHeroGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_352_5446)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_352_5446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1201.28 406.927C1210.45 283.916 1399.31 318.472 1399.31 318.472C1399.31 318.472 1580.67 336.163 1684.71 406.927C1814.75 495.383 1543.2 738.016 1399.31 773.563C1255.43 809.111 1189.81 560.691 1201.28 406.927Z",
    fill: "url(#paint0_linear_352_5446)",
    style: {
      mixBlendMode: "color"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_352_5446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-57.7219 48.9272C-48.5514 -74.084 140.314 -39.5284 140.314 -39.5284C140.314 -39.5284 321.669 -21.8373 425.707 48.9272C555.754 137.383 284.196 380.016 140.314 415.563C-3.56841 451.111 -69.1851 202.691 -57.7219 48.9272Z",
    fill: "url(#paint1_linear_352_5446)",
    style: {
      mixBlendMode: "color"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1472 216.832C1302.79 163.077 700.131 -33.8386 651.255 95.1752C590.16 256.443 1231.43 172.397 909.988 459.778C610.437 727.591 68.1902 309.845 287.133 129.291C421.675 18.3393 0.044268 -136.683 -143 4.25576",
    stroke: "url(#paint2_linear_352_5446)",
    strokeWidth: 13
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_352_5446",
    x: 968,
    y: 82,
    width: 983,
    height: 927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 116,
    result: "effect1_foregroundBlur_352_5446"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_352_5446",
    x: -291,
    y: -276,
    width: 983,
    height: 927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 116,
    result: "effect1_foregroundBlur_352_5446"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_352_5446",
    x1: 1660.68,
    y1: -2750.79,
    x2: 2673.56,
    y2: -2651.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AB2D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_352_5446",
    x1: 401.678,
    y1: -3108.79,
    x2: 1414.56,
    y2: -3009.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AB2D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_352_5446",
    x1: 999.353,
    y1: -49.863,
    x2: 186.764,
    y2: 9.35887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390231,
    stopColor: "#0E97EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819851,
    stopColor: "#23C7CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_352_5446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 620,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfTechWeekHeroGraphic);
export default __webpack_public_path__ + "static/media/sf-tech-week-hero-graphic.9b88c26afd793ee988b27feb7465c290.svg";
export { ForwardRef as ReactComponent };